import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "crm:max-w-[128px]"
}

import BagdeNew from "../components/BadgeNew.vue";
import {arrows_down, arrows_up} from "../svg/svgs.js"
import {computed, inject} from "vue";

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */

export default {
  __name: 'AppSidebarNavigationItem',
  props: {
  /**
   * Dati del singolo elemento di menu
   */
  item: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * Se true indica che la sidebar è aperta
   */
  is_sidebar_open: {
    type: Boolean,
    default: false
  }
},
  emits: [
  /**
   * emitta l'apertura del sotto-menu di una voce (se presente)
   */
  'toggle:expand'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Renderizza e gestisce una singola voce di menu
 * @requires ./TheMainSidebar.vue
 */
const $DesignSystem = inject('$DesignSystem')

const props = __props

const emits = __emit

const isDisable = computed(() => (props.item['disable'] !== undefined && props.item.disable));
const haveLink = computed(() => props.item['link'] !== undefined && props.item.link !== '')

const itemNavigation = computed(() => props.item)

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (itemNavigation.value['is_popover'] === undefined)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(!haveLink.value || isDisable.value ? 'span' : 'a'), {
        key: 0,
        href: !haveLink.value || isDisable.value ? '' : itemNavigation.value.link,
        class: _normalizeClass(["crm:flex crm:items-center", {
      'crm:opacity-50 crm:cursor-not-allowed ': itemNavigation.value.disable,
      'crm:justify-center':!__props.is_sidebar_open,
      'crm:text-primary! crm:font-bold': itemNavigation.value.is_active || itemNavigation.value.isExpand,
      'crm:hover:text-primary crm:cursor-pointer': !itemNavigation.value.disable}]),
        onClick: _cache[0] || (_cache[0] = $event => (emits('toggle:expand', itemNavigation.value)))
      }, {
        default: _withCtx(() => [
          (itemNavigation.value.icon)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                "stroke-width": itemNavigation.value.isExpand || itemNavigation.value.is_active ? '1.5' : '1',
                icon: itemNavigation.value.icon,
                class: _normalizeClass({'crm:mr-4': __props.is_sidebar_open}),
                stroke: itemNavigation.value.is_active || itemNavigation.value.isExpand ? _unref($DesignSystem).design_colors.primary : '#111'
              }, null, 8 /* PROPS */, ["stroke-width", "icon", "class", "stroke"]))
            : _createCommentVNode("v-if", true),
          (!itemNavigation.value.icon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["crm:w-[20px]", {'crm:mr-4 crm:inline-block': __props.is_sidebar_open}])
              }, null, 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (__props.is_sidebar_open)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(itemNavigation.value.text), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (__props.is_sidebar_open && itemNavigation.value.is_new)
            ? (_openBlock(), _createBlock(BagdeNew, { key: 3 }))
            : _createCommentVNode("v-if", true),
          (itemNavigation.value.children && __props.is_sidebar_open)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 4,
                icon: itemNavigation.value.isExpand ? _unref(arrows_up) : _unref(arrows_down),
                class: "crm:ml-1",
                sizing: {width: '10px', height: '10px'}
              }, null, 8 /* PROPS */, ["icon"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href", "class"]))
    : _createCommentVNode("v-if", true)
}
}

}